import axiosInstance from '@/setup/axios/axiosInstance'
import {AuthModel} from '../models/AuthModel'
import {UserModel} from '../models/UserModel'

interface CompanyListResponse<T> {
  results?: T[]
}

interface BasicCompany {
  id: string
  name: string
  code: string
  company_type: string
}

// Server should return AuthModel
export function login(email: string, password: string) {
  // console.log('🌐 AuthCRUD.login called with:', { email, password: password ? '***' : 'empty' });
  return axiosInstance.post('/accounts/login/', {email, password})
}

// Server should return AuthModel
export function register(email: string, firstname: string, lastname: string, password: string) {
  return axiosInstance.post<AuthModel>('/auth/register', {
    email,
    firstname,
    lastname,
    password,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axiosInstance.post<{result: boolean}>('/auth/forgot-password', {email})
}

export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  // Check common redux folder => setupAxios
  return axiosInstance.get<UserModel>('/accounts/profile/')
}

export type UpdateProfilePayload = {
  first_name?: string
  last_name?: string
  email?: string
  username?: string
}

export function updateUserProfile(data: UpdateProfilePayload | FormData) {
  if (data instanceof FormData) {
    return axiosInstance.patch<UserModel>('/accounts/profile/', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }

  return axiosInstance.patch<UserModel>('/accounts/profile/', data)
}

export function getUserCompaniesAndRoles() {
  return axiosInstance.get('/accounts/users/user_companies_and_roles/')
    .then(response => {
      
      return response;
    })
    .catch(error => {
      console.error('📡 API CALL: getUserCompaniesAndRoles - ERROR:', error);
      throw error;
    });
}

export async function getAllCompaniesForGlobalSelection() {
  const response = await axiosInstance.get<BasicCompany[] | CompanyListResponse<BasicCompany>>('/companies/')
  const payload = response.data as BasicCompany[] | CompanyListResponse<BasicCompany>

  if (Array.isArray(payload)) {
    return payload
  }

  return Array.isArray(payload?.results) ? payload.results : []
}
